import { createFileRoute } from '@tanstack/react-router';

import { DebugTable } from '../features/debug/components/DebugTable/DebugTable';
import { debugRouteSearchSchema } from '../features/debug/debugRouteSearch';

export const Route = createFileRoute('/debug')({
  validateSearch: debugRouteSearchSchema,
  component: DebugTable,
});
